import React, { useState } from "react";
import Icon from '@mdi/react';
import {mdiChatOutline } from '@mdi/js';
import {mdiTwitter } from '@mdi/js';
import {mdiWhatsapp } from '@mdi/js';
import {mdiEmailOutline } from '@mdi/js';
import { mdiLinkedin } from "@mdi/js";
import { Link } from "react-router-dom";

const SocialSharing = (props) => {

    const windowFeatures = 'width=400,height=400 top=200,left=600';

    const stringify = (dgarray) =>{
        let ttg  = "";
        for(let i=0; i < dgarray.length; i++){

            if(i < dgarray.length-1){

                ttg+= dgarray[i].name+",";
            }else{
                ttg+= dgarray[i].name
            }   
        }
        return ttg;
    }

    const facebookshare = () =>{

        window.open("https://www.facebook.com/dialog/share?app_id=301384265897415&display=popup&href="+props.url+"&redirect_uri="+props.url, "Facebook", windowFeatures);
        return
       
    }

    const twittershare = () =>{

        window.open("https://twitter.com/share?url="+props.url+"&text="+props.title+"&hashtags="+stringify(props.tags).replace(/\s/g,''), "Twitter", windowFeatures);
        return

    }

    const whatsappshare = () => {

        window.open("whatsapp://send?text="+props.title+" , See More: "+ props.url, "Whatsapp", windowFeatures)
        return
    }


    const emailshare = () => {

        window.open("mailto:?Subject="+props.title+"&Body="+props.url, "Email", windowFeatures)
        return
    }

    const linkshare = () => {

        window.open("http://www.linkedin.com/shareArticle?mini=true&url="+props.url,"LinkedIn", windowFeatures)

    }

    

    return(
    <>
      <div id="social_media_sharing_buttons" className="interactiveicons">
         <Link id={"fbshare"+props.url} onClick={facebookshare} className="fb"><i className="fa fa-facebook" aria-hidden="true" title="Facebook"></i></Link>
         <Link  id={"twittershare"+props.url} onClick={twittershare} className="twitter"><i class="fa-brands fa-x-twitter"></i></Link>
        <Link id={"whatsappshare"+props.url} data-action="share/whatsapp/share"  onClick={whatsappshare}  className="whatsapp" ><i class="fa fa-whatsapp" aria-hidden="true"></i></Link>
        <Link id={"linked"+props.url} onClick={linkshare} className="lin"><i className="fa fa-linkedin" aria-hidden="true"></i></Link>
        <Link id={"emailshare"+props.url} onClick={emailshare} className="email"><i className="fa fa-envelope" aria-hidden="true"></i></Link> 
    </div>
    </>
    )
}

export default SocialSharing;